<script>
	import boxBase from '@_system/components/base/box.vue'
	export default {
		extends: boxBase,
		name: 'box',
		props: {

		},
		data() {
			return {
				// containerId: 'box_' + Math.random(),
				action: '',
				popoverDisabled: true
			}
		},
		watch: {

		},
		created() {
			if (!this.parentControll) {
				this.unlock()
			} else {
				this.popoverDisabled = this.parentControll.props.disabled
			}
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			lock() {
				this.popoverDisabled = true
			},
			unlock() {
				this.popoverDisabled = false
			},
			// setComponent(component) {
			// 	this.component = component
			// 	document.getElementById(this.containerId + '_id').appendChild(component.$el)
			// },
			submit(close, action = 'submit') {
				let data = {}
				let postdata = {}
				let columns = this.$refs[this.ref].getTableColumn().fullColumn
				columns.forEach((item) => {
					if (item.field) {
						data[item.field] = null
					}
				})
				if (this.moduleName != '') {
					postdata = {
						type: 'add',
						moduleName: this.moduleName,
						boxTable: this.$refs[this.ref],
						action: action,
						data: this.selectType === 'radio' ? this.$refs[this.ref].getRadioRecord() : this.$refs[this
							.ref].getCheckboxRecords(),

					}
					if (action == 'clear') {
						postdata.data = data
					}
					this.$emit('submit', postdata)
				} else {
					postdata = {
						boxTable: this.$refs[this.ref],
						action: action,
						data: this.component.$refs[this.component.gridref].getTableData(),
					}
					if (action == 'clear') {
						postdata.data = data
					}
					this.$emit('submit', postdata)

				}
				this.close(close)
			},
			submitwidthreflash(data) {
				this.$emit('submit', {
					type: 'flash',
					moduleName: this.moduleName,
					boxTable: null,
					data: data
				})
			},
			hide() {
				let postdata = {}
				if (this.moduleName == '') {
					postdata = {
						boxTable: this.$refs[this.ref],
						data: this.component.$refs[this.component.gridref].getTableData()
					}
					this.$emit('submit', postdata)
				}
				this.opacity = 1
			}

		},
		components: {

		}
	}
</script>
